import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { BACKEND_URL } from '../consts';
import { validateEmail, validatePassword } from '../util';

const Registration = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [isVisible, setIsVisible] = useState(false);

    const [check1, setCheck1] = useState(false)
    const [check2, setCheck2] = useState(false)

    const [emailBorderColor, setEmailBorderColor] = useState('#353A40');
    const [passwordBorderColor, setPasswordBorderColor] = useState('#353A40');
    const [confirmBorderColor, setConfirmBorderColor] = useState('#353A40');

    const [emailImg, setEmailImg] = useState("./ula.png");
    const [passwordImg, setPasswordImg] = useState("./unhidden.png");
    const [confirmImg, setConfirmImg] = useState('./hidden.png');
    const [searchParams, setSearchParams] = useSearchParams();
    const referralId = searchParams.get("ref");

    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);
        if (validateEmail(value)) {
            setEmailBorderColor('#34C759'); // зеленый при валидном email
            setEmailImg("./Succes.png");
            localStorage.setItem("email", value);
        } else {
            setEmailBorderColor('#C3372E'); // красный при ошибке
            setEmailImg("./dot-error.png");
        }
    };

    const handlePasswordChange = (e) => {
        const value = e.target.value;
        setPassword(value);
        if (validatePassword(value)) {
            setPasswordBorderColor('#34C759'); // зеленый при валидном пароле
            setPasswordImg(isVisible ? "./hidden.png" : "./unhidden.png");
            localStorage.setItem("password", value);
        } else {
            setPasswordBorderColor('#C3372E'); // красный при ошибке
            setPasswordImg("./hidden-error.png");
        }
    };

    const handleConfirmChange = (e) => {
        const value = e.target.value;
        setConfirm(value);
        if (value === password && validatePassword(value)) {
            setConfirmBorderColor('#34C759'); // зеленый при совпадении паролей
            setPasswordBorderColor('#34C759'); // зеленый при валидном пароле
            setConfirmImg(isVisible ? "./hidden.png" : "./unhidden.png");
        } else {
            setConfirmBorderColor('#C3372E'); // красный при ошибке
            setPasswordBorderColor('#C3372E'); // красный при ошибке
            setConfirmImg("./hidden-error.png");
        }
    };

    const togglePasswordVisibility = () => {
        setIsVisible(!isVisible);
        // Обновляем изображение в зависимости от состояния видимости
        if (!isVisible) {
            setPasswordImg("./hidden.png"); // Показываем скрытый значок
            setConfirmImg("./hidden.png"); // Показываем скрытый значок для подтверждения пароля
        } else {
            setPasswordImg("./unhidden.png"); // Показываем открытый значок
            setConfirmImg("./unhidden.png"); // Показываем открытый значок для подтверждения пароля
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault(); // предотвращаем перезагрузку страницы
        if (validateEmail(email) && validatePassword(password) && password === confirm && check1 && check2) {
            try {
                let queryParams = {};

                if (referralId) {
                    queryParams["ref"] = referralId;
                }

                const response = await fetch(`${BACKEND_URL}/api/v1/auth/registration?` + new URLSearchParams(queryParams), {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ email, password }),
                });

                if (!response.ok) {
                    throw new Error('Ошибка при регистрации');
                }

                const data = await response.json();
                localStorage.setItem('email', email);
                localStorage.setItem('confirm', JSON.stringify(data.confirmation_code)); // Сохраняем ответ в localStorage
                console.log('Ответ от сервера:', data);
                window.location.replace('/confirm')
                // Здесь можно добавить логику для перехода на другую страницу или уведомления пользователя
            } catch (error) {
                console.error('Ошибка:', error);
                alert('Ошибка при регистрации: ' + error.message); // Показать ошибку пользователю
            }
        } else {
            alert('Пожалуйста, проверьте введенные данные.');
        }
    };
    return (
        <>
            <div className='w-full p-8 h-screen hidden lg:grid lg:grid-cols-2'>
                <div className='w-full h-full gap-4 items-center justify-center flex flex-col items-center'>
                    <img className='h-9 w-9' src='./ula.png' alt="Logo" />
                    <span className='font-medium text-[40px]'>Начните сейчас</span>
                    <span className='text-[16px] text-[#4B535B]'>Укажите свои данные для аккаунта</span>

                    <div className={`py-2 px-4 w-[60%] flex justify-between items-center flex-row rounded-2xl border-[1px]`} style={{ borderColor: emailBorderColor }}>
                        <div className='w-full flex flex-col'>
                            <span className='text-[14px] text-[#626C75]'>Электронная почта</span>
                            <input autoComplete={"off"} type="text" value={email} onChange={handleEmailChange} />
                        </div>
                        <img className='h-7 w-7' src={emailImg} />
                    </div>

                    <div className={`py-2 px-4 w-[60%] flex justify-between items-center flex-row rounded-2xl border-[1px]`} style={{ borderColor: passwordBorderColor }}>
                        <div className='w-full flex flex-col'>
                            <span className='text-[14px] text-[#626C75]'>Пароль</span>
                            <input autoComplete={"off"} type={isVisible ? 'text' : 'password'} value={password} onChange={handlePasswordChange} />
                        </div>
                        <img className='h-7 w-7' src={passwordImg} onClick={togglePasswordVisibility} alt="Hidden" />
                    </div>

                    <div className={`py-2 px-4 w-[60%] flex justify-between items-center flex-row rounded-2xl border-[1px]`} style={{ borderColor: confirmBorderColor }}>
                        <div className='w-full flex flex-col'>
                            <span className='text-[14px] text-[#626C75]'>Повторите пароль</span>
                            <input autoComplete={"off"} type={isVisible ? 'text' : 'password'} value={confirm} onChange={handleConfirmChange} />
                        </div>
                        <img className='h-7 w-7' src={passwordImg} onClick={togglePasswordVisibility} alt="Hidden" />
                    </div>

                    <div onClick={() => setCheck1(!check1)} className='w-[60%] text-[#4B535B] gap-4 flex justify-between flex-row'>
                        <div style={{ aspectRatio: 1 }} className={`border-[1px] flex items-center justify-center ${check1 ? 'bg-[#353A40]' : 'bg-transparent'} border-black h-[20px] rounded-md`}>
                            {check1 && <img className='w-[80%] h-[80%]' src='./checkImg.png' alt="Checked" />}
                        </div>

                        <span className='text-[12px]'>* Я подтверждаю, что ознакомлен(-на) с публичной офертой и политикой конфиденциальности, и принимаю их положения.</span>
                    </div>

                    <div onClick={() => setCheck2(!check2)} className='w-[60%] text-[#4B535B] gap-4 flex justify-between flex-row'>
                        <div style={{ aspectRatio: 1 }} className={`border-[1px] flex items-center justify-center ${check2 ? 'bg-[#353A40]' : 'bg-transparent'} border-black h-[20px] rounded-md`}>
                            {check2 && <img className='w-[80%] h-[80%]' src='./checkImg.png' alt="Checked" />}
                        </div>

                        <span className='text-[12px]'>Я согласен(-на) получать от Meest China сообщения по электронной связи, например, по электронной почте и/или SMS, персонализированные маркетинговые материалы, приспособленные к моему клиентскому профилю, в частности, к моим покупательским предпочтениям.</span>
                    </div>


                    <div className='w-[60%] gap-4 flex flex-row items-center'>
                        <div
                            className={`k h-[20px] rounded-md flex items-center justify-center cursor-pointer`}
                        >
                        </div>

                        <span className='text-normal'>Подробнее</span>
                    </div>

                    <div className='flex flex-row justify-between rounded-full w-[60%] py-3 px-5 bg-[#C3372E] hover:bg-[#E0473F]' onClick={handleSubmit}>
                        <span className='text-white text-[20px'>Присоедениться</span>
                        <img className='w-7' src='./Arrow_right.png' />
                    </div>

                    <div className='flex flex-row items-center gap-8'>
                        <span className='text'>
                            У вас уже есть аккаунт?
                        </span>
                        <a href="/login">
                            <span onClick={() => window.location.replace("/login")} className='rounded-full border-[1px] border-black py-2 px-5 hover:text-white hover:bg-[#353A40]'>
                                Войти
                            </span>

                        </a>
                    </div>

                </div>

                <img style={{ aspectRatio: 1 }} className='w-full my-auto' src='/AuthBg.png' />
            </div>












            <div className='w-full p-8 min-h-screen hidden sm:grid lg:hidden lg:grid-cols-1'>
                <img className='w-full my-auto' src='/AuthBgLaptop.png' />

                <div className='w-full h-full gap-4 items-center justify-center flex flex-col items-center'>
                    <img className='h-9 w-9' src='./ula.png' alt="Logo" />
                    <span className='font-medium text-[40px]'>Начните сейчас</span>
                    <span className='text-[16px] text-[#4B535B]'>Укажите свои данные для аккаунта</span>

                    <div className={`py-2 px-4 w-[80%] flex justify-between items-center flex-row rounded-2xl border-[1px]`} style={{ borderColor: emailBorderColor }}>
                        <div className='w-full flex flex-col'>
                            <span className='text-[14px] text-[#626C75]'>Электронная почта</span>
                            <input autoComplete={"off"} type="text" value={email} onChange={handleEmailChange} />
                        </div>
                        <img className='h-7 w-7' src={emailImg} />
                    </div>

                    <div className={`py-2 px-4 w-[80%] flex justify-between items-center flex-row rounded-2xl border-[1px]`} style={{ borderColor: passwordBorderColor }}>
                        <div className='w-full flex flex-col'>
                            <span className='text-[14px] text-[#626C75]'>Пароль</span>
                            <input autoComplete={"off"} type={isVisible ? 'text' : 'password'} value={password} onChange={handlePasswordChange} />
                        </div>
                        <img className='h-7 w-7' src={passwordImg} onClick={togglePasswordVisibility} alt="Hidden" />
                    </div>
                    <div className={`py-2 px-4 w-[80%] flex justify-between items-center flex-row rounded-2xl border-[1px]`} style={{ borderColor: confirmBorderColor }}>
                        <div className='w-full flex flex-col'>
                            <span className='text-[14px] text-[#626C75]'>Повторите пароль</span>
                            <input autoComplete={"off"} type={isVisible ? 'text' : 'password'} value={confirm} onChange={handleConfirmChange} />
                        </div>
                        <img className='h-7 w-7' src={passwordImg} onClick={togglePasswordVisibility} alt="Hidden" />
                    </div>

                    <div onClick={() => setCheck1(!check1)} className='w-[80%] text-[#4B535B] gap-4 flex justify-between flex-row'>
                        <div style={{ aspectRatio: 1 }} className={`border-[1px] flex items-center justify-center ${check1 ? 'bg-[#353A40]' : 'bg-transparent'} border-black h-[20px] rounded-md`}>
                            {check1 && <img className='w-[80%] h-[80%]' src='./checkImg.png' alt="Checked" />}
                        </div>

                        <span className='text-[12px]'>* Я подтверждаю, что ознакомлен(-на) с публичной офертой и политикой конфиденциальности, и принимаю их положения.</span>
                    </div>

                    <div onClick={() => setCheck2(!check2)} className='w-[80%] text-[#4B535B] gap-4 flex justify-between flex-row'>
                        <div style={{ aspectRatio: 1 }} className={`border-[1px] flex items-center justify-center ${check2 ? 'bg-[#353A40]' : 'bg-transparent'} border-black h-[20px] rounded-md`}>
                            {check2 && <img className='w-[80%] h-[80%]' src='./checkImg.png' alt="Checked" />}
                        </div>

                        <span className='text-[12px]'>Я согласен(-на) получать от Meest China сообщения по электронной связи, например, по электронной почте и/или SMS, персонализированные маркетинговые материалы, приспособленные к моему клиентскому профилю, в частности, к моим покупательским предпочтениям.</span>
                    </div>


                    <div className='w-[80%] gap-4 flex flex-row items-center'>
                        <div
                            className={`k h-[20px] rounded-md flex items-center justify-center cursor-pointer`}
                        >
                        </div>

                        <span className='text-normal'>Подробнее</span>
                    </div>

                    <div className='flex flex-row justify-between rounded-full w-[80%] py-3 px-5 bg-[#C3372E] hover:bg-[#E0473F]' onClick={handleSubmit}>
                        <span className='text-white text-[20px'>Присоедениться</span>
                        <img className='w-7' src='./Arrow_right.png' />
                    </div>

                    <div className='flex flex-row items-center gap-8'>
                        <span className='text'>
                            У вас уже есть аккаунт?
                        </span>

                        <a href="/login">
                            <span className='rounded-full border-[1px] border-black py-2 px-5 hover:text-white hover:bg-[#353A40]'>
                                Войти
                            </span>
                        </a>

                    </div>

                </div>

            </div>









            <div className='w-full p-8 min-h-screen grid sm:hidden lg:grid-cols-1'>

                <div className='w-full h-full gap-4 items-center justify-center flex flex-col items-center'>
                    <img className='h-9 w-9' src='./ula.png' alt="Logo" />
                    <span className='font-medium text-[40px]'>Начните сейчас</span>
                    <span className='text-[16px] text-[#4B535B]'>Укажите свои данные для аккаунта</span>

                    <div className={`py-2 px-4 w-[95%] flex justify-between items-center flex-row rounded-2xl border-[1px]`} style={{ borderColor: emailBorderColor }}>
                        <div className='w-full flex flex-col'>
                            <span className='text-[14px] text-[#626C75]'>Электронная почта</span>
                            <input autoComplete={"off"} type="text" value={email} onChange={handleEmailChange} />
                        </div>
                        <img className='h-7 w-7' src={emailImg} />
                    </div>

                    <div className={`py-2 px-4 w-[95%] flex justify-between items-center flex-row rounded-2xl border-[1px]`} style={{ borderColor: passwordBorderColor }}>
                        <div className='w-full flex flex-col'>
                            <span className='text-[14px] text-[#626C75]'>Пароль</span>
                            <input autoComplete={"off"} type={isVisible ? 'text' : 'password'} value={password} onChange={handlePasswordChange} />
                        </div>
                        <img className='h-7 w-7' src={passwordImg} onClick={togglePasswordVisibility} alt="Hidden" />
                    </div>
                    <div className={`py-2 px-4 w-[95%] flex justify-between items-center flex-row rounded-2xl border-[1px]`} style={{ borderColor: confirmBorderColor }}>
                        <div className='w-full flex flex-col'>
                            <span className='text-[14px] text-[#626C75]'>Повторите пароль</span>
                            <input autoComplete={"off"} type={isVisible ? 'text' : 'password'} value={confirm} onChange={handleConfirmChange} />
                        </div>
                        <img className='h-7 w-7' src={passwordImg} onClick={togglePasswordVisibility} alt="Hidden" />
                    </div>

                    <div onClick={() => setCheck1(!check1)} className='w-[95%] text-[#4B535B] gap-4 flex justify-between flex-row'>
                        <div style={{ aspectRatio: 1 }} className={`border-[1px] flex items-center justify-center ${check1 ? 'bg-[#353A40]' : 'bg-transparent'} border-black h-[20px] rounded-md`}>
                            {check1 && <img className='w-[95%] h-[80%]' src='./checkImg.png' alt="Checked" />}
                        </div>

                        <span className='text-[12px]'>* Я подтверждаю, что ознакомлен(-на) с публичной офертой и политикой конфиденциальности, и принимаю их положения.</span>
                    </div>

                    <div onClick={() => setCheck2(!check2)} className='w-[95%] text-[#4B535B] gap-4 flex justify-between flex-row'>
                        <div style={{ aspectRatio: 1 }} className={`border-[1px] flex items-center justify-center ${check2 ? 'bg-[#353A40]' : 'bg-transparent'} border-black h-[20px] rounded-md`}>
                            {check2 && <img className='w-[95%] h-[80%]' src='./checkImg.png' alt="Checked" />}
                        </div>

                        <span className='text-[12px]'>Я согласен(-на) получать от Meest China сообщения по электронной связи, например, по электронной почте и/или SMS, персонализированные маркетинговые материалы, приспособленные к моему клиентскому профилю, в частности, к моим покупательским предпочтениям.</span>
                    </div>


                    <div className='w-[95%] gap-4 flex flex-row items-center'>
                        <div
                            className={`k h-[20px] rounded-md flex items-center justify-center cursor-pointer`}
                        >
                        </div>

                        <span className='text-normal'>Подробнее</span>
                    </div>

                    <div className='flex flex-row justify-between rounded-full w-[95%] py-3 px-5 bg-[#C3372E] hover:bg-[#E0473F]' onClick={handleSubmit}>
                        <span className='text-white text-[20px'>Присоедениться</span>
                        <img className='w-7' src='./Arrow_right.png' />
                    </div>

                    <div className='flex flex-row items-center gap-8'>
                        <span className='text'>
                            У вас уже есть аккаунт?
                        </span>

                        <a href="/login">
                            <span className='rounded-full border-[1px] border-black py-2 px-5 hover:text-white hover:bg-[#353A40]'>
                                Войти
                            </span>

                        </a>
                    </div>

                </div>

                <img className='w-full mt-8 my-auto' src='/AuthBgMobile.png' />

            </div>
        </>

    );
};

export default Registration;

